export enum ReportTypeEnum {
  Mobilytics = "mobilytics",
  RetailMatch = "retailmatch",
}
